export const brandExclusions: { [key: string]: string[] } = {
  aerosleep: ['es-es', 'it-it'],
  puckababy: ['es-es', 'it-it'],
  // Add more brands and their exclusions here
};
